import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "../../../design_system/components/Button/Button";
import { Icons } from "../../../design_system/components/Icons";

const destinationLabel = (path) => {
    if (path === "/prospects") return "Go to Prospects";
    if (path === "/directory") return "Go to Directory";
    if (path === "/reports") return "Go to Reports";
    if (path === "/mapper-suggestions") return "Go to Mapper Suggestions";
    if (path === "/feed") return "Go to Newsfeed";
    return "Go to available content";
};

const NoAccessPage = ({ embedded = false }) => {
    const history = useHistory();
    const location = useLocation();
    const homePath = useSelector((state) => state.current_team.team?.home_path);
    const safeDestination = homePath &&
        homePath !== "/no-access" &&
        homePath !== location.pathname
        ? homePath
        : null;

    return (
        <main
            className={`no-access-page${embedded ? " no-access-page--embedded" : ""}`}
            aria-labelledby="no-access-title"
        >
            <div className="no-access-page__content">
                <div className="no-access-page__icon" aria-hidden="true">
                    <Icons name="lock" size={40} />
                </div>
                <div className="no-access-page__copy">
                    <h1 id="no-access-title" className="headline-l-bold color-text-primary">
                        You don&apos;t have access to this page.
                    </h1>
                    <p className="body-m color-text-secondary">
                        Ask a team admin to give you access.
                    </p>
                </div>
                {safeDestination && (
                    <Button
                        Size="Medium"
                        Type="Primary"
                        onClick={() => history.push(safeDestination)}
                    >
                        {destinationLabel(safeDestination)}
                    </Button>
                )}
            </div>
        </main>
    );
};

export default NoAccessPage;
